import React, { useState, useEffect, useCallback } from "react";
import "../style/checkout.css";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import ITooltip from "../../../Component/Common/ITooltip";
import CartModal from "../../../Component/Common/CartModal";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
import { getcart, persistCartContext, } from "../service/cart.service";
import { deleteCartItem } from "../service/deletecartItem.serves";
import { addToCart } from "../../ProductDetail/service/productcart.service";
import CartEmpty from "../../../Component/error/CartEmpty";
import Proceedcustomer from "../../../Component/Common/Proceedcheckout";
import { getCheckoutProcess } from "../service/CheckoutProcess.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setCartCount,
  setPreCartCount,
} from "../../Cart/redux/cartSlice";

import { getCartCount } from "../../../Component/header/service/CartCount.service";
import "../../../assets/css/Customermodalbox.css";
import { getHoldOrders, moveCart } from "../../Account/service/HoldOrder.service";
import HoldOrder from "../component/HoldConfirm";
function CartPage() 
{
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalDesignShade, setModalDesignShade] = useState("");
  const [loading, setLoading] = useState(true);
  const [quantityLoading, setQuantityLoading] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [cartSummary, setCartSummary] = useState({});
  const [cartTempToken, setCartTempToken] = useState("");
  const [cartCustomer, setCartCustomer] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [points, setPoints] = useState("");
  const [applied, setApplied] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [showHoldConfirm, setShowHoldConfirm] = useState(false);
  const [holdOrders, setHoldOrders] = useState([]);
  const [checkingHoldOrders, setCheckingHoldOrders] = useState(false);
  const [holdingOrder, setHoldingOrder] = useState(false);


  /* ============================================================
  CART CONTEXT
  ============================================================ */
const [searchParams] = useSearchParams();
const comingsoon =
  searchParams.get("comingsoon") === "1";

const getCartContext = useCallback(() => {
  const cartType = comingsoon
    ? "pre"
    : "fresh";

  const userId = Number(
    localStorage.getItem("userId") || 1
  );

  const customerId = Number(
    localStorage.getItem("customerId") || 0
  );

  return {
    cartType,
    userId,
    customerId,
  };
}, [comingsoon]);


  /* ============================================================
  CART COUNT
  ============================================================ */

const syncCartCount = useCallback(async () => {
  try {
    const {
      cartType,
      userId,
      customerId,
    } = getCartContext();

    if (!userId) {
      if (cartType === "pre") {
        dispatch(setPreCartCount(0));
      } else {
        dispatch(setCartCount(0));
      }

      return 0;
    }

    const response = await getCartCount(
      cartType,
      userId,
      customerId || null
    );

    const count = Number(
      response?.data?.count ??
      response?.data?.cart_count ??
      response?.data?.total_items ??
      response?.count ??
      response?.cart_count ??
      response?.total_items ??
      0
    );

    if (cartType === "pre") {
      dispatch(setPreCartCount(count));
    } else {
      dispatch(setCartCount(count));
    }

    return count;

  } catch (error) {
    console.error(
      "Cart Count Sync Error:",
      error
    );

    return 0;
  }
}, [dispatch, getCartContext]);


  /* ============================================================
  LOAD CART
  ============================================================ */

  const loadCart = useCallback(
    async (showLoader = true) => {
      if (showLoader) {
        setLoading(true);
      }

      try {
        const {
          cartType,
          userId,
          customerId,
        } = getCartContext();

        if (!userId) {
          setCartItems([]);
          setCartSummary({});
          setCartTempToken("");
          setCartCustomer({});
          setSelectedCustomer(null);

          dispatch(setCartCount(0));

          return;
        }

        persistCartContext({
          cartType,
          userId,
          customerId,
        });

        const data = await getcart(
          cartType,
          userId,
          customerId || null
        );

        /* ======================================================
        CART ITEMS
        ====================================================== */

        const items =
          data?.cartItems ||
          data?.cart_items ||
          data?.data?.cartItems ||
          data?.data?.cart_items ||
          data?.data?.items ||
          data?.items ||
          [];

        /* ======================================================
        CART SUMMARY
        ====================================================== */

        const summary =
          data?.cartSummary ||
          data?.cart_summary ||
          data?.data?.cartSummary ||
          data?.data?.cart_summary ||
          data?.summary ||
          data?.data?.summary ||
          {};

        /* ======================================================
        CUSTOMER
        ====================================================== */

        const customer =
          data?.cartCustomer ||
          data?.cart_customers ||
          data?.customer ||
          data?.data?.cartCustomer ||
          data?.data?.cart_customers ||
          data?.data?.customer ||
          {};

        /* ======================================================
        TEMP TOKEN
        ====================================================== */

        const tempToken =
          data?.cartTempToken ||
          data?.cart_temp_token ||
          data?.temp_token ||
          data?.cart_token ||
          data?.data?.cartTempToken ||
          data?.data?.cart_temp_token ||
          data?.data?.temp_token ||
          data?.data?.cart_token ||
          "";

        /* ======================================================
        SET CART ITEMS
        ====================================================== */

        setCartItems(
          Array.isArray(items)
            ? items
            : []
        );

        /* ======================================================
        SET SUMMARY
        ====================================================== */

        setCartSummary(
          summary &&
            typeof summary === "object"
            ? summary
            : {}
        );

        /* ======================================================
        SET TEMP TOKEN
        ====================================================== */

        setCartTempToken(
          tempToken || ""
        );

        /* ======================================================
        SET CUSTOMER
        
        Only initial/cart API customer.
        Customer dropdown change will NOT call loadCart().
        ====================================================== */

        const validCustomer =
          customer &&
            typeof customer === "object"
            ? customer
            : {};

        setCartCustomer(
          validCustomer
        );

        /*
        Initial customer ko selectedCustomer me bhi set karo.
        Isse UI me selected customer properly show hoga.
        */
        if (
          Object.keys(validCustomer)
            .length > 0
        ) {
          setSelectedCustomer(
            validCustomer
          );

          const selectedId =
            validCustomer?.id ??
            validCustomer?.customer_id ??
            validCustomer?.customerId;

          if (selectedId) {
            localStorage.setItem(
              "customerId",
              String(selectedId)
            );

            localStorage.setItem(
              "selectedCustomer",
              JSON.stringify(
                validCustomer
              )
            );
          }
        }

        await syncCartCount();
      } catch (error) {
        console.error(
          "Load Cart Error:",
          error
        );

        setCartItems([]);
        setCartSummary({});
        setCartTempToken("");
        setCartCustomer({});
        setSelectedCustomer(null);

        dispatch(setCartCount(0));
      } finally {
        if (showLoader) {
          setLoading(false);
        }
      }
    },
    [
      dispatch,
      getCartContext,
      syncCartCount,
    ]
  );

  /* ============================================================
  INITIAL CART LOAD
  ============================================================ */

 useEffect(() => {
  loadCart(true);
}, [loadCart, comingsoon]);

  /* ============================================================
  RESTORE SELECTED CUSTOMER
  ============================================================ */

  useEffect(() => {
    try {
      const savedCustomer =
        JSON.parse(
          localStorage.getItem(
            "selectedCustomer"
          ) || "null"
        );

      if (
        savedCustomer &&
        typeof savedCustomer === "object"
      ) {
        setSelectedCustomer(
          savedCustomer
        );
      }
    } catch (error) {
      console.error(
        "Selected Customer Restore Error:",
        error
      );
    }
  }, []);

  /* ============================================================
  RESTORE APPLIED POINTS
  ============================================================ */

  useEffect(() => {
    try {
      const savedPoints =
        JSON.parse(
          localStorage.getItem(
            "appliedPoints"
          ) || "null"
        );

      if (
        savedPoints?.applied &&
        Number(savedPoints?.points) > 0
      ) {
        setApplied(true);

        setPoints(
          String(savedPoints.points)
        );
      }
    } catch (error) {
      console.error(
        "Applied Points Restore Error:",
        error
      );
    }
  }, []);

  /* ============================================================
  QUANTITY STATE AFTER CART LOAD
  ============================================================ */

  useEffect(() => {
    const qtyObj = {};

    cartItems.forEach((item) => {
      const cartId =
        item.cart_id ?? item.id;

      if (cartId !== undefined) {
        qtyObj[cartId] = String(
          item.quantity ?? 1
        );
      }
    });

    setQuantities(qtyObj);
  }, [cartItems]);

  /* ============================================================
  AVAILABLE LOYALTY POINTS
  ============================================================ */

  const availableLoyaltyPoints =
    Number(
      selectedCustomer?.loyalityAvailPoints ??
      selectedCustomer?.avail_points ??
      selectedCustomer?.loyalty_points ??
      selectedCustomer?.available_points ??
      cartCustomer?.loyalityAvailPoints ??
      cartCustomer?.avail_points ??
      cartCustomer?.loyalty_points ??
      cartCustomer?.available_points ??
      0
    );

  /* ============================================================
  APPLY POINTS
  ============================================================ */

  const handleApply = () => {
    const availablePoints =
      Number(
        selectedCustomer?.loyalityAvailPoints ??
        selectedCustomer?.avail_points ??
        selectedCustomer?.loyalty_points ??
        selectedCustomer?.available_points ??
        cartCustomer?.loyalityAvailPoints ??
        cartCustomer?.avail_points ??
        cartCustomer?.loyalty_points ??
        0
      );

    const redeemPoints =
      Number(points);

    if (availablePoints < 5000) {
      toast.error(
        "Available points should be at least 5000."
      );
      return;
    }

    if (!redeemPoints) {
      toast.error(
        "Please enter redeem points."
      );
      return;
    }

    if (redeemPoints < 5000) {
      toast.error(
        "Minimum redeem points is 5000."
      );
      return;
    }

    if (
      redeemPoints >
      availablePoints
    ) {
      toast.error(
        `You can redeem a maximum of ${availablePoints} points.`
      );
      return;
    }

    setApplied(true);

    localStorage.setItem(
      "appliedPoints",
      JSON.stringify({
        applied: true,
        points: redeemPoints,
      })
    );

    toast.success(
      "Points Applied Successfully"
    );
  };

  /* ============================================================
  REMOVE POINTS
  ============================================================ */

  const handleRemovePoints = () => {
    setApplied(false);
    setPoints("");

    localStorage.removeItem(
      "appliedPoints"
    );

    toast.success(
      "Points Removed Successfully"
    );
  };

  /* ============================================================
  CUSTOMER CHANGE
  ============================================================ */

  const handleCustomerChange = (
    customer
  ) => {
    if (!customer) {
      return;
    }

    /* ========================================================
    CUSTOMER ID
    ======================================================== */

    const customerId =
      customer?.id ??
      customer?.customer_id ??
      customer?.customerId;

    if (!customerId) {
      toast.error(
        "Customer ID not found"
      );
      return;
    }

    /* ========================================================
    LOYALTY POINTS
    ======================================================== */

    const loyaltyPoints =
      Number(
        customer?.loyalityAvailPoints ??
        customer?.avail_points ??
        customer?.loyalty_points ??
        customer?.available_points ??
        0
      );

    /* ========================================================
    NORMALIZED CUSTOMER
    ======================================================== */

    const updatedCustomer = {
      ...customer,

      id: customerId,

      avail_points:
        loyaltyPoints,

      loyalityAvailPoints:
        loyaltyPoints,
    };

    /* ========================================================
    UPDATE SELECTED CUSTOMER
    ======================================================== */

    setSelectedCustomer(
      updatedCustomer
    );

    /* ========================================================
    UPDATE DISPLAY CUSTOMER
    
    IMPORTANT:
    Previous customer ko spread/merge nahi karna.
    Direct new customer object set karna hai.
    ======================================================== */

    setCartCustomer(
      updatedCustomer
    );

    /* ========================================================
    SAVE CUSTOMER ID
    ======================================================== */

    localStorage.setItem(
      "customerId",
      String(customerId)
    );

    /* ========================================================
    SAVE SELECTED CUSTOMER
    ======================================================== */

    localStorage.setItem(
      "selectedCustomer",
      JSON.stringify(
        updatedCustomer
      )
    );

    /* ========================================================
    RESET OLD CUSTOMER POINTS
    ======================================================== */

    setApplied(false);
    setPoints("");

    localStorage.removeItem(
      "appliedPoints"
    );
  };

  /* ============================================================
  CHECKOUT
  ============================================================ */

  const handleProceedCheckout =
    async () => {
      try {
        let customer =
          selectedCustomer;

        /* ======================================================
        FALLBACK LOCAL STORAGE
        ====================================================== */

        if (!customer) {
          try {
            customer =
              JSON.parse(
                localStorage.getItem(
                  "selectedCustomer"
                ) || "null"
              );
          } catch (error) {
            console.error(
              "Customer Parse Error:",
              error
            );
          }
        }

        /* ======================================================
        FALLBACK CART CUSTOMER
        ====================================================== */

        if (!customer) {
          customer =
            cartCustomer;
        }

        const customerId =
          customer?.id ??
          customer?.customer_id ??
          customer?.customerId;

        if (!customerId) {
          toast.error(
            "Please select customer"
          );
          return;
        }

        if (!cartTempToken) {
          toast.error(
            "Cart session not found"
          );
          return;
        }

        const {
          cartType,
        } = getCartContext();

        const payload = {
          customer_id:
            Number(customerId),

          cart_type:
            cartType,

          points:
            applied
              ? Number(points)
              : 0,
        };

        const response =
          await getCheckoutProcess(
            cartTempToken,
            payload
          );

        if (
          response?.success !== false
        ) {
          localStorage.removeItem(
            "appliedPoints"
          );

          navigate(
            `/checkout/${encodeURIComponent(
              cartTempToken
            )}/summary`
          );
        } else {
          toast.error(
            response?.message ||
            "Checkout failed"
          );
        }
      } catch (error) {
        console.error(
          "Checkout Error:",
          error
        );

        toast.error(
          error?.response?.data
            ?.message ||
          error?.message ||
          "Checkout failed"
        );
      }
    };

  /* ============================================================
  IMAGE MODAL
  ============================================================ */

  const handleImageClick = (
    image,
    designShade
  ) => {
    setModalImage(
      image || ""
    );

    setModalDesignShade(
      designShade || ""
    );

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  /* ============================================================
  DELETE CART ITEM
  ============================================================ */

  const handleDelete = async (
    cartId
  ) => {
    if (!cartId) {
      toast.error(
        "Cart item ID not found"
      );
      return;
    }

    try {
      const result =
        await deleteCartItem(
          cartId
        );

      if (
        result?.success ||
        result?.data?.success
      ) {
        toast.success(
          "Item deleted successfully"
        );

        await loadCart(false);
      } else {
        toast.error(
          result?.message ||
          result?.data?.message ||
          "Failed to delete item"
        );
      }
    } catch (error) {
      console.error(
        "Delete Error:",
        error
      );

      toast.error(
        error?.response?.data
          ?.message ||
        error?.message ||
        "Failed to delete item"
      );
    }
  };

  /* ============================================================
  QUANTITY UPDATE
  ============================================================ */

const handleQuantityChange = async (
  item,
  quantity
) => {
  const cartId = item.cart_id ?? item.id;

  const requestedQuantity = Number(quantity);

  const maxStock = Number(
    item.available_stock ||
    item.stock ||
    0
  );

  const oldQuantity = Number(
    item.quantity || 1
  );

  // Out of stock
  if (maxStock <= 0) {
    toast.error(
      "Product is out of stock"
    );

    return;
  }

  // Stock exceed hone par API call mat karo
  if (requestedQuantity > maxStock) {
    toast.error(
      `Only ${maxStock} stock available`
    );

    // User ki typed value preserve rahegi
    setQuantities((prev) => ({
      ...prev,
      [cartId]: String(requestedQuantity),
    }));

    return;
  }

  let finalQuantity = requestedQuantity;

  if (finalQuantity < 1) {
    finalQuantity = 1;
  }

  if (finalQuantity === oldQuantity) {
    setQuantities((prev) => ({
      ...prev,
      [cartId]: String(finalQuantity),
    }));

    return;
  }

  try {
    setQuantityLoading((prev) => ({
      ...prev,
      [cartId]: true,
    }));

    const {
      cartType,
      userId,
      customerId,
    } = getCartContext();

    if (!userId) {
      toast.error(
        "Cart session not found"
      );
      return;
    }

    const payload = {
      cart_type: cartType,
      user_id: userId,
      customer_id: customerId || null,
      product_listing_id:
        item.product_listing_id ||
        item.product_id,
      qty: finalQuantity,
    };

    const res = await addToCart(payload);

    const success =
      res?.success === true ||
      res?.data?.success === true ||
      res?.status === true;

    if (!success) {
      toast.error(
        res?.message ||
        res?.data?.message ||
        "Quantity update failed"
      );

      setQuantities((prev) => ({
        ...prev,
        [cartId]: String(oldQuantity),
      }));

      return;
    }

    persistCartContext({
      cartType,
      userId,
      customerId,
    });

    await loadCart(false);

    toast.success(
      "Quantity Updated Successfully"
    );

  } catch (error) {
    console.error(
      "Quantity Update Error:",
      error
    );

    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Quantity update failed"
    );

    setQuantities((prev) => ({
      ...prev,
      [cartId]: String(oldQuantity),
    }));

  } finally {
    setQuantityLoading((prev) => ({
      ...prev,
      [cartId]: false,
    }));
  }
};

  /* ============================================================
  PLUS
  ============================================================ */

  const handleIncrease = (
    item
  ) => {
    const cartId =
      item.cart_id ?? item.id;

    const currentQty =
      Number(
        quantities[cartId] ??
        item.quantity ??
        1
      );

    const availableStock =
      Number(
        item.available_stock ||
        item.stock ||
        0
      );

    if (
      availableStock <= 0
    ) {
      toast.error(
        "Product is out of stock"
      );
      return;
    }

    if (
      currentQty >=
      availableStock
    ) {
      toast.error(
        `Only ${availableStock} quantity available`
      );
      return;
    }

    const newQty =
      currentQty + 1;

    setQuantities(
      (prev) => ({
        ...prev,
        [cartId]:
          String(newQty),
      })
    );

    handleQuantityChange(
      item,
      newQty
    );
  };

  /* ============================================================
  MINUS
  ============================================================ */

  const handleDecrease = (
    item
  ) => {
    const cartId =
      item.cart_id ?? item.id;

    const currentQty =
      Number(
        quantities[cartId] ??
        item.quantity ??
        1
      );

    if (
      currentQty <= 1
    ) {
      return;
    }

    const newQty =
      currentQty - 1;

    setQuantities(
      (prev) => ({
        ...prev,
        [cartId]:
          String(newQty),
      })
    );

    handleQuantityChange(
      item,
      newQty
    );
  };

  /* ============================================================
  QUANTITY INPUT
  ============================================================ */

const handleQuantityInput = (item, value) => {
  const cartId = item.cart_id ?? item.id;

  // Empty allow karo taaki user freely type kar sake
  if (value === "") {
    setQuantities((prev) => ({
      ...prev,
      [cartId]: "",
    }));
    return;
  }

  // Sirf numbers allow
  if (!/^\d+$/.test(value)) {
    return;
  }

  const qty = Number(value);

  const maxStock = Number(
    item.available_stock ||
    item.stock ||
    0
  );

  // Input ko stock par clamp MAT karo
  // User jo type karega wahi input me dikhega
  setQuantities((prev) => ({
    ...prev,
    [cartId]: value,
  }));

  // Stock exceed hone par sirf message
  if (maxStock <= 0) {
    toast.error("Product is out of stock");
    return;
  }

  if (qty > maxStock) {
    toast.error(
      `Only ${maxStock} stock available`
    );
  }
};


/* ============================================================
   QUANTITY BLUR
============================================================ */

const handleQuantityBlur = (item) => {
  const cartId = item.cart_id ?? item.id;

  const maxStock = Number(
    item.available_stock ||
    item.stock ||
    0
  );

  let qty = Number(
    quantities[cartId]
  );

  const oldQuantity = Number(
    item.quantity || 1
  );

  // Out of stock
  if (maxStock <= 0) {
    setQuantities((prev) => ({
      ...prev,
      [cartId]: "0",
    }));

    toast.error(
      "Product is out of stock"
    );

    return;
  }

  // Empty / invalid quantity
  if (!qty || qty < 1) {
    qty = 1;

    setQuantities((prev) => ({
      ...prev,
      [cartId]: "1",
    }));

    if (oldQuantity !== 1) {
      handleQuantityChange(item, 1);
    }

    return;
  }

  // Stock se zyada hai
  // Input ko change MAT karo
  if (qty > maxStock) {
    toast.error(
      `Only ${maxStock} stock available`
    );

    // 20 typed hai to 20 hi rahega
    setQuantities((prev) => ({
      ...prev,
      [cartId]: String(qty),
    }));

    return;
  }

  // Valid quantity
  setQuantities((prev) => ({
    ...prev,
    [cartId]: String(qty),
  }));

  // Sirf valid quantity API me bhejo
  if (qty !== oldQuantity) {
    handleQuantityChange(item, qty);
  }
};

  /* ============================================================
  OUT OF STOCK
  ============================================================ */

  const hasOutOfStock =
    cartItems.some(
      (item) => {
        const status =
          String(
            item.stock_status ||
            ""
          )
            .toLowerCase()
            .replace(
              /\s+/g,
              "_"
            );

        return (
          status ===
          "out_of_stock" ||
          Number(
            item.available_stock ||
            0
          ) <= 0
        );
      }
    );

    /*=============================
      Hold Order 
    =============================*/

const handleHoldOrderClick = async () => {
  try {
    setCheckingHoldOrders(true);

    /* ======================================================
       CURRENT CUSTOMER
    ====================================================== */

    const customer =
      selectedCustomer ||
      cartCustomer ||
      JSON.parse(
        localStorage.getItem("selectedCustomer") || "null"
      );

    const currentCustomerId = Number(
      customer?.id ??
      customer?.customer_id ??
      customer?.customerId ??
      localStorage.getItem("customerId") ??
      0
    );

    if (!currentCustomerId) {
      toast.error("Please select customer first.");
      return;
    }

    /* ======================================================
       CURRENT CART CHECK
    ====================================================== */

    if (!cartTempToken) {
      toast.error("Cart token not found.");
      return;
    }

    /* ======================================================
       GET HOLD ORDERS
    ====================================================== */

    const response = await getHoldOrders();

    const orders =
      Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response)
        ? response
        : [];

    /* ======================================================
       CHECK SAME CUSTOMER ALREADY HAS HOLD ORDER
    ====================================================== */

    const customerAlreadyHasHoldOrder = orders.some(
      (order) => {
        const holdCustomer =
          order?.cart_customers ||
          order?.cart_customer ||
          order?.customer ||
          {};

        const holdCustomerId = Number(
          holdCustomer?.id ??
          holdCustomer?.customer_id ??
          holdCustomer?.customerId ??
          order?.customer_id ??
          order?.customerId ??
          0
        );

        return holdCustomerId === currentCustomerId;
      }
    );

    /* ======================================================
       SAME CUSTOMER FOUND
    ====================================================== */

    if (customerAlreadyHasHoldOrder) {
      toast.error(
        "This customer already has a hold order. You cannot hold another order for this customer."
      );

      setHoldOrders(orders);
      setShowHoldConfirm(false);

      return;
    }

    /* ======================================================
       CUSTOMER DOES NOT HAVE HOLD ORDER
    ====================================================== */

    setHoldOrders(orders);
    setShowHoldConfirm(true);

  } catch (error) {
    console.error(
      "Get Hold Orders Error:",
      error
    );

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to check hold orders"
    );
  } finally {
    setCheckingHoldOrders(false);
  }
};


const handleConfirmHoldOrder = async () => {
  try {
    setHoldingOrder(true);
    if (!cartTempToken) {
      toast.error("Cart token not found");
      return;
    }
    const response = await moveCart(
      cartTempToken,
      "hold"
    );
    const success =
      response?.success === true ||
      response?.status === true ||
      response?.data?.success === true;

    if (!success) {
      toast.error(
        response?.message ||
          response?.data?.message ||
          "Unable to hold order"
      );

      return;
    }
    toast.success(
      "Order hold successfully"
    );
    setShowHoldConfirm(false);
    setHoldOrders([]);
    await loadCart(false);
    await syncCartCount();
  } catch (error) {
    console.error(
      "Confirm Hold Order Error:",
      error
    );

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to hold order"
    );
  } finally {
    setHoldingOrder(false);
  }
};


  /* ============================================================
  EMPTY CART
  ============================================================ */

  if (
    !loading &&
    cartItems.length === 0
  ) {
    return (
      <>
        <Toaster position="top-right" />
        <CartEmpty />
      </>
    );
  }

  /* ============================================================
  RENDER
  ============================================================ */

  const hasInvalidQuantity = cartItems.some((item) => {
  const cartId = item.cart_id ?? item.id;
  const quantity = Number(
    quantities[cartId] ?? item.quantity ?? 1
  );
  const stock = Number(
    item.available_stock ??
    item.stock ??
    0
  );
  return stock <= 0 || quantity > stock;
});

  return (
    <>
      <Breadcrumb
        items={[
          {
            name: "Cart",
          },
        ]}
      />

      <Toaster
        position="top-right"
        reverseOrder={false}
      />

      <div className="TableBoxCheckout">
        <div className="container">
          <div className="row">

                {/* ===================
                LEFT CART
                ======================= */}

            <div className="col-md-9 col-md-9-left">

              <div className="checkout-box-summary">

                <div className="table-box-content">

                  <div className="table-responsive">

                    <table className="table table-lg table-boxrto mb-0 checkoutcart-table">

                      {/* HEADER */}

                      {loading ? (
                        <thead>
                          <tr>
                            <td colSpan="9">
                              <Skeleton
                                height={50}
                              />
                            </td>
                          </tr>
                        </thead>
                      ) : (
                        <thead className="text-center">
                          <tr>

                            <th
                              className="table-header"
                              width="75"
                            >
                              Image
                            </th>

                            <th className="table-header">
                              Design Shade
                            </th>

                            <th className="table-header">
                              Size
                            </th>

                            <th className="table-header">
                              Stock
                            </th>

                            <th className="table-header">
                              Order Qty.
                            </th>

                            <th className="table-header">
                              GST (%)
                            </th>

                            <th className="table-header text-right">
                              MRP (
                              <i className="bi bi-currency-rupee"></i>
                              )
                            </th>

                            <th className="table-header text-right">
                              Amt (
                              <i className="bi bi-currency-rupee"></i>
                              )
                            </th>

                            <th
                              className="table-header"
                              width="90"
                            >
                              &nbsp;
                            </th>

                          </tr>
                        </thead>
                      )}

                      {/* BODY */}

                      <tbody>

                        {loading ? (
                          <tr>
                            <td colSpan="9">
                              <Skeleton
                                height={50}
                                count={2}
                              />
                            </td>
                          </tr>
                        ) : cartItems.length > 0 ? (

                          cartItems.map(
                            (item) => {

                              const cartId =
                                item.cart_id ??
                                item.id;

                              const currentQty =
                                Number(
                                  quantities[
                                  cartId
                                  ] ??
                                  item.quantity ??
                                  1
                                );

                              const stock =
                                Number(
                                  item.available_stock ||
                                  item.stock ||
                                  0
                                );

                              const isUpdating =
                                Boolean(
                                  quantityLoading[
                                  cartId
                                  ]
                                );

                              const status =
                                String(
                                  item.stock_status ||
                                  ""
                                )
                                  .toLowerCase()
                                  .replace(
                                    /\s+/g,
                                    "_"
                                  );

                              const isOutOfStock =
                                status ===
                                "out_of_stock" ||
                                stock <= 0;

                              return (
                                <tr
                                  key={cartId}
                                  className={
                                    isOutOfStock
                                      ? "out-stock-row"
                                      : ""
                                  }
                                >

                                  {/* IMAGE */}

                                  <td
                                    className="align-middle"
                                    style={{
                                      width:
                                        "90px",
                                    }}
                                  >

                                    {item.design_shade_image ? (

                                      <img
                                        src={
                                          item.design_shade_image
                                        }
                                        alt={
                                          item.design_shade ||
                                          "Product"
                                        }
                                        width="50"
                                        style={{
                                          cursor:
                                            "pointer",
                                          objectFit:
                                            "contain",
                                        }}
                                        onClick={() =>
                                          handleImageClick(
                                            item.design_shade_image,
                                            item.design_shade
                                          )
                                        }
                                      />

                                    ) : (
                                      <span>
                                        No Image
                                      </span>
                                    )}

                                  </td>

                                  {/* DESIGN SHADE */}

                                  <td className="align-middle">

                                    <strong className="contentsize">
                                      {item.design_shade ||
                                        item.design ||
                                        "-"}
                                    </strong>

                                    {isOutOfStock && (
                                      <div className="out-stock-text">
                                        Out of Stock
                                      </div>
                                    )}

                                  </td>

                                  {/* SIZE */}

                                  <td className="text-center align-middle">
                                    {item.size ||
                                      "-"}
                                  </td>

                                  {/* STOCK */}

                                  <td className="text-center align-middle">
                                    {item.available_stock ??
                                      item.stock ??
                                      0}
                                  </td>

                                  {/* QUANTITY */}

                                  <td className="text-center align-middle">
  <div className="quantity-box">
    {isUpdating ? (
      <div className="quantity-loader">
        <span className="spinner-border spinner-border-sm" />
      </div>
    ) : (
      <>
        <button
          type="button"
          disabled={
            currentQty <= 1 ||
            stock <= 0
          }
          onClick={() => handleDecrease(item)}
        >
          -
        </button>

        <input
          type="number"
          min="1"
          max={stock}
          disabled={stock <= 0}
          value={
            quantities[cartId] ??
            String(item.quantity ?? 1)
          }
          onChange={(e) =>
            handleQuantityInput(
              item,
              e.target.value
            )
          }
          onBlur={() =>
            handleQuantityBlur(item)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
        />

        <button
          type="button"
          disabled={
            currentQty >= stock ||
            stock <= 0
          }
          onClick={() => handleIncrease(item)}
        >
          +
        </button>
      </>
    )}
  </div>
</td>

                                  {/* GST */}

                                  <td className="text-center align-middle">
                                    {item.gst ?? 0}
                                  </td>

                                  {/* MRP */}

                                  <td className="text-end align-middle">
                                    {Number(
                                      item.mrp ||
                                      0
                                    ).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  {/* TOTAL */}

                                  <td className="text-end align-middle">
                                    {Number(
                                      item.total_price ||
                                      item.total_amount ||
                                      item.amount ||
                                      0
                                    ).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  {/* DELETE */}

                                  <td className="text-center align-middle">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      disabled={
                                        isUpdating
                                      }
                                      onClick={() =>
                                        handleDelete(
                                          cartId
                                        )
                                      }
                                    >
                                      <i className="bi bi-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              );
                            }
                          )

                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center"
                            >
                              No Cart Data Found
                            </td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* ==================================================
RIGHT SUMMARY
================================================== */}

            <div className="col-md-3 col-md-3-right">
              <div className="box-amount">

                {/* CUSTOMER */}

                {loading ? (
                  <Skeleton height={40} />
                ) : (

                  <div
                    style={{
                      background:
                        "#f2f2f2",
                      width: "100%",
                      fontWeight:
                        "bold",
                      marginBottom:
                        "8px",
                      padding:
                        "7px 5px 7px 8px",
                      borderRadius:
                        "4px",
                    }}
                  >

                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fontsizeCustomer">
                        {selectedCustomer?.customer_name ||
                          selectedCustomer?.customerName ||
                          selectedCustomer?.accountName ||
                          selectedCustomer?.name ||
                          cartCustomer?.customer_name ||
                          cartCustomer?.customerName ||
                          cartCustomer?.accountName ||
                          "No Customer Selected"}
                      </span>

                      <Proceedcustomer
                        checkoutId={
                          cartTempToken
                        }
                        cartType={
                          getCartContext()
                            .cartType
                        }
                        onCustomerChange={
                          handleCustomerChange
                        }
                      />
                    </div>
                  </div>
                )}

                {/* SUMMARY */}

                {loading ? (
                  <Skeleton
                    height={20}
                    count={4}
                  />
                ) : (
                  <>

                    {/* ORDER QTY */}

                    <div className="d-flex mb-1">
                      <span> Order Qty. </span>
                      <div className="ml-auto">
                        <span
                          className="update-qty"
                          style={{
                            marginRight:
                              "16px",
                          }}
                        >
                          <strong>
                            {Number(
                              cartSummary?.total_quantity ??
                              cartSummary?.total_qty ??
                              cartItems.reduce(
                                (
                                  total,
                                  item
                                ) =>
                                  total +
                                  Number(
                                    item.quantity ||
                                    0
                                  ),
                                0
                              )
                            )}
                          </strong>
                        </span>
                      </div>
                    </div>

                    {/* SUBTOTAL */}

                    <div className="d-flex mb-1">

                      <span> Subtotal </span>

                      <div className="ml-auto">
                        <span className="update-qty">
                          <strong>

                            <i className="bi bi-currency-rupee"></i>{" "}

                            {Number(
                              cartSummary?.subtotal ||
                              0
                            ).toLocaleString(
                              "en-IN"
                            )}

                          </strong>
                        </span>
                      </div>
                    </div>

                    {/* LOYALTY POINTS */}

                    <div
                      className="d-flex align-items-center"
                      style={{
                        borderTop:
                          "1px solid #d9cfcf",
                        borderBottom:
                          "1px solid #d9cfcf",
                        padding:
                          "6px 0",
                      }}
                    >

                      <div
                        style={{
                          display:
                            "inline-flex",
                          width:
                            "150px",
                        }}
                      >

                        <ITooltip />
                        &nbsp;
                        Avail. Points :&nbsp;

                        <span
                          id="rpoint"
                          style={{
                            fontSize:
                              "13px",
                          }}
                        >
                          {Number(
                            availableLoyaltyPoints
                          ).toLocaleString(
                            "en-IN"
                          )}
                        </span>
                      </div>

                      <div id="r-point" className="ml-auto mb-0 pointbox" >
                        <div className="input-group input-group-sm">
                          <input
                            type="number"
                            className="form-control border-warning shadow-none"
                            value={points}
                            disabled={
                              applied
                            }
                            min="0"
                            max={
                              availableLoyaltyPoints
                            }
                            onChange={(e) =>
                              setPoints(
                                e.target.value
                              )
                            }
                          />

                          <div className="input-group-append">
                            {applied ? (

                              <button
                                className="btn apply"
                                type="button"
                                onClick={
                                  handleRemovePoints
                                }
                              >
                                Remove
                              </button>

                            ) : (

                              <button
                                className="btn apply"
                                type="button"
                                onClick={
                                  handleApply
                                }
                                disabled={
                                  availableLoyaltyPoints <
                                  5000
                                }
                                style={{
                                  background:
                                    "#f7d42e",
                                }}
                              >
                                Apply
                              </button>
                            )}

                          </div>
                        </div>
                      </div>
                    </div>

                  </>
                )}

                {/* CHECKOUT */}

                {loading ? (
                  <Skeleton height={40} />
                ) : (
                  <>
                    <div className="mt-2">
  {hasOutOfStock ? (
    <button
      type="button"
      className="btn btn-disable w-100"
      disabled
      style={{
        background: "#ccc",
        cursor: "not-allowed",
      }}
    >
      Remove Out of Stock Product
    </button>
  ) : hasInvalidQuantity ? (
    <button
      type="button"
      className="btn btn-disable w-100"
      disabled
      style={{
        background: "#ccc",
        cursor: "not-allowed",
      }}
    >
      Quantity Exceeds Stock
    </button>
  ) : (
    <button
      type="button"
      className="btn btn-primary-yellow"
      onClick={handleProceedCheckout}
    >
      Proceed To CheckOut
    </button>
  )}
</div>

                    <button
                        type="button"
                        className="btn hold-orderbtn w-100"
                        onClick={handleHoldOrderClick}
                        disabled={checkingHoldOrders || holdingOrder}
                      >
                       {checkingHoldOrders ? (
                          <>
                            <span className="hold-spinner" />
                            Checking...
                          </>
                        ) : (
                          "HOLD ORDER"
                        )}
                      </button>

                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

     <HoldOrder
  showHoldConfirm={showHoldConfirm}
  setShowHoldConfirm={setShowHoldConfirm}
  holdOrders={holdOrders}
  holdingOrder={holdingOrder}
  handleConfirmHoldOrder={handleConfirmHoldOrder}
/>

      {/* IMAGE MODAL */}

      <CartModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalImage={modalImage}
        designShade={modalDesignShade}
      />
    </>
  );
}
export default CartPage;